module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/wedding-banner-da81f85b551d7bbca6c0e65fdadb2b4e.png";